export const routeProps = {
  path: '/package',
  exact: true,
};

export default () => routeProps;
